// Copyright 2024 - MinIO, Inc. All rights reserved.

import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "api";
import { ApiError } from "api/observeApi";
import { RootState } from "app/store";

export const validateLicense = createAsyncThunk(
  "setup/validateLicense",
  async (_, { getState, rejectWithValue, dispatch }) => {
    const state = getState() as RootState;

    const jwt = state.setup.jwt;

    return api.setup
      .setupLicenseValidate(
        { jwt: jwt },
        {
          format: "json",
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        dispatch(setupConfigAsync());
        return res;
      })
      .catch((e) => {
        const err = e.error as ApiError;
        return rejectWithValue(err);
      });
  },
);

export const setupConfigAsync = createAsyncThunk(
  "setup/setupConfigAsync",
  async (_, { rejectWithValue }) => {
    return api.setup
      .setupConfig()
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        const err = e.error as ApiError;
        return rejectWithValue(err);
      });
  },
);

export const finishSetupAsync = createAsyncThunk(
  "setup/finishSetupAsync",
  async (_, { rejectWithValue, getState }) => {
    const state = getState() as RootState;
    const jwt = state.setup.jwt;
    const uiEndpoint = state.setup.uiEndpoint;
    const apiEndpoint = state.setup.apiEndpoint;
    const apiPort = state.setup.apiPort;
    const username = state.setup.username;
    const password = state.setup.password;

    return api.setup
      .setSetupConfig({
        ui_endpoint: uiEndpoint,
        api_endpoint: apiEndpoint,
        api_port: apiPort,
        email: username,
        password: password,
        jwt: jwt,
      })
      .then((res) => {
        return res.data;
      })
      .catch((e) => {
        const err = e.error as ApiError;
        return rejectWithValue(err);
      });
  },
);

export const joinControlPlaneAsync = createAsyncThunk(
  "setup/joinControlPlaneAsync",
  async (_, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const endpoint = state.setup.endpoint;
    const psk = state.setup.psk;
    const caHash = state.setup.caHash;
    const siteName = state.setup.siteName;
    return api.setup
      .setupJoin({
        psk: psk,
        api_endpoint: endpoint,
        ca_hash: caHash,
        site_name: siteName,
      })
      .then((res) => {
        return res.data;
      })
      .catch(async (e) => {
        const err = (await e.json()) as ApiError;
        return rejectWithValue(err);
      });
  },
);
